var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7471 30.9785C55.7471 44.7855 44.5541 55.9785 30.7471 55.9785C16.9399 55.9785 5.74707 44.7855 5.74707 30.9785C5.74707 17.1714 16.9399 5.97852 30.7471 5.97852C44.5541 5.97852 55.7471 17.1714 55.7471 30.9785ZM40.8228 23.4027C41.5551 24.1349 41.5551 25.3221 40.8228 26.0543L28.3228 38.5543C27.5906 39.2865 26.4036 39.2865 25.6712 38.5543L20.6712 33.5543C19.939 32.822 19.939 31.635 20.6712 30.9028C21.4035 30.1705 22.5907 30.1705 23.3229 30.9028L26.9971 34.5768L32.5841 28.9898L38.1713 23.4027C38.9036 22.6705 40.0906 22.6705 40.8228 23.4027Z",
    fill: "#44E397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/success_circle.a66c00246e451dc6d4e9eeeab08ca041.svg";
export { ForwardRef as ReactComponent };